import React from 'react';
import { PageHeader } from '../components/PageHeader';
export function BestProductPage() {
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D]" data-id="element-410">
      <PageHeader title="Best Product" data-id="element-411" />
    </div>;
}